import React from "react"
import PropTypes from "prop-types"
import {
  reservationTitle,
  reservationSubContainerWithStep,
} from "../Part3/reservation-part-3.module.scss"
import {
  reservationCheckbox,
  reservationChoiceTypeContainer,
  reservationPart4Container,
  reservationPart4FormContainer,
  reservationPart4CaseCochable,
  checkIcon,
  spanContainer,
} from "./reservation-part-4.module.scss"
import {
  ReservationSubContainer,
  ReservationTitle,
  ReservationPart4Input,
  ReservationPart4TextArea,
  ReservationInputType,
} from "../reservation-styled.js"
import { StepIndicator } from "../StepIndicator/step-indicator"

export const ReservationPart4 = ({
  contactInfo,
  setContactInfo,
  commentairePossible,
  casesCochables,
  textesSupplementaires,
  step,
  stepRefs,
}) => {
  const handleChange = (event) => {
    setContactInfo({ ...contactInfo, [event.target.name]: event.target.value })
  }

  const handleCheckbox = (event) => {
    const index = event.target.getAttribute("data-index")
    const cases = contactInfo.cases
    cases[index] = event.target.checked
    setContactInfo({ ...contactInfo, cases: cases })
  }

  const handleTextesSupplementaires = (event) => {
    const index = event.target.getAttribute("data-index")
    const textes = contactInfo.textes
    textes[index] = event.target.value
    setContactInfo({ ...contactInfo, textes: textes })
  }

  return (
    <ReservationSubContainer className={reservationSubContainerWithStep}>
      <StepIndicator step={step} refs={stepRefs} />
      <ReservationTitle className={reservationTitle}>
        Informations de contact
      </ReservationTitle>
      <div className={reservationPart4Container}>
        <p>
          Pour la gestion de votre réservation, nous avons besoin de vos
          informations de contact. Veuillez bien remplir les champs ci-dessous
          (tous les champs marqués d&apos;une * sont obligatoires).
        </p>
        <div className={reservationPart4FormContainer}>
          <form>
            <label htmlFor="prenom">
              Prénom*
              <ReservationPart4Input
                type="text"
                id="prenom"
                name="prenom"
                autoComplete="given-name"
                onChange={handleChange}
                value={contactInfo.prenom}
                required={true}
              />
            </label>
            <label htmlFor="nom">
              Nom*
              <ReservationPart4Input
                type="text"
                id="nom"
                name="nom"
                autoComplete="family-name"
                onChange={handleChange}
                value={contactInfo.nom}
                required={true}
              />
            </label>
            <label htmlFor="phone">
              Téléphone*
              <ReservationPart4Input
                type="tel"
                id="phone"
                name="phone"
                autoComplete={"tel"}
                onChange={handleChange}
                value={contactInfo.phone}
                required
              />
            </label>
            <label htmlFor="mail">
              E-mail*
              <ReservationPart4Input
                type="email"
                id="mail"
                name="mail"
                autoComplete={"email"}
                value={contactInfo.mail}
                onChange={handleChange}
                required
              />
            </label>
            {textesSupplementaires && (
              <>
                {textesSupplementaires.map((texteSupplementaire, index) => (
                  <label htmlFor={"texte" + index} key={index}>
                    {texteSupplementaire.value}
                    <ReservationPart4Input
                      type="text"
                      id={"texte" + index}
                      name={"texte" + index}
                      onChange={handleTextesSupplementaires}
                      data-index={index}
                    />{" "}
                  </label>
                ))}
              </>
            )}
            {commentairePossible && (
              <label htmlFor="comm">
                Commentaire
                <ReservationPart4TextArea
                  type="text"
                  rows={10}
                  id="comm"
                  name="comm"
                  value={contactInfo.comm}
                  onChange={handleChange}
                />
              </label>
            )}
            {casesCochables && (
              <div
                className={reservationChoiceTypeContainer}
                role={"group"}
                aria-label={"Options supplémentaires"}
              >
                {casesCochables.map((caseCochable, index) => (
                  <div key={index}>
                    <label
                      className={reservationPart4CaseCochable}
                      htmlFor={"case" + index}
                    >
                      <ReservationInputType
                        type="checkbox"
                        className={reservationCheckbox}
                        name={"case" + index}
                        id={"case" + index}
                        checked={contactInfo.cases[index]}
                        onChange={handleCheckbox}
                        data-index={index}
                      />{" "}
                      <div className={spanContainer}>
                        <span className={checkIcon} aria-hidden={true}></span>
                        <span>{caseCochable.value}</span>
                      </div>
                    </label>
                  </div>
                ))}
              </div>
            )}
          </form>
        </div>
      </div>
    </ReservationSubContainer>
  )
}

ReservationPart4.propTypes = {
  contactInfo: PropTypes.object,
  setContactInfo: PropTypes.func,
  commentairePossible: PropTypes.bool,
  casesCochables: PropTypes.array,
  textesSupplementaires: PropTypes.array,
  step: PropTypes.number,
  stepRefs: PropTypes.arrayOf(PropTypes.shape({ current: PropTypes.any })),
}
